import React from "react";
import { Select, SelectOption } from "@showitinc/showit-wc";

import SiteDesignStore from "../stores/SiteDesignStore";
import useStoreState from "./providers/useStoreState";
import { isPageTargetValid } from "../utils/LinkUtils";

const GroupTitle = ({ title }) => (
  <SelectOption disabled value="disabled">
    {title}
  </SelectOption>
);

const PageSelectInput = (props) => {
  const pages = useStoreState(SiteDesignStore, SiteDesignStore.getPageList);

  const [pageOptions, wpOptions] = pages.reduce(
    (result, page) => {
      const groupIndex = page.has("wp") ? 1 : 0;
      const slug = page.get("slug");

      result[groupIndex].push(
        <SelectOption
          data-testid={`page-option-${slug}`}
          key={`opt-${groupIndex}-${slug}`}
          value={slug}
        >
          {page.get("name")}
        </SelectOption>
      );

      return result;
    },
    [
      [<GroupTitle key="pages-group" title="Pages" />],
      [<GroupTitle key="blog-templates-group" title="Blog Templates" />],
    ]
  );

  const value = isPageTargetValid(props.value) ? props.value : null;

  return (
    <Select {...props} value={value} filter>
      <SelectOption data-testid="page-option-none" key="opt-none" value="">
        Select page
      </SelectOption>
      {pageOptions.length > 1 && pageOptions}
      {wpOptions.length > 1 && wpOptions}
    </Select>
  );
};

export default PageSelectInput;
